export const INVITATIONS_QUERY_KEY_BASE = 'invitations';
export const InvitationsKeyFactory = {
    exact: (invitationId) => [INVITATIONS_QUERY_KEY_BASE, invitationId],
};
const ORGANIZATION_INVITATIONS_KEY_BASE = 'organizations';
export const OrganizationInvitationsKeyFactory = {
    all: () => [INVITATIONS_QUERY_KEY_BASE, ORGANIZATION_INVITATIONS_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...OrganizationInvitationsKeyFactory.all(),
        workspaceId,
    ],
};
const INDIVIDUAL_INVITATIONS_KEY_BASE = 'individual_invitations';
export const IndividualInvitationsKeyFactory = {
    byWorkspace: (workspaceId) => [
        INDIVIDUAL_INVITATIONS_KEY_BASE,
        workspaceId,
    ],
};
const INDIVIDUAL_INVITATION_KEY = 'individual_invitation';
export const IndividualInvitationKeyFactory = {
    all: () => [INDIVIDUAL_INVITATION_KEY],
    byWorkspace: (workspaceId) => [
        ...IndividualInvitationKeyFactory.all(),
        workspaceId,
    ],
    exact: (workspaceId, invitationId) => [
        ...IndividualInvitationKeyFactory.byWorkspace(workspaceId),
        invitationId,
    ],
};
export const INVITATION_INFO_KEY_BASE = 'invitation_info';
export const IndividualInvitationInfoKeyFactory = {
    exact: (invitationId) => [INVITATION_INFO_KEY_BASE, invitationId],
};
